import { ApplicationData } from "../ls2pac/ApplicationData";
import { LS2KIDS_CONSTANTS } from "./constants";

export const seriesLogo = function ( logo, height, width ) {
    //			if( arguments.length == 1 ) {
    //				throw "A height and width is required for images from the CCS.";
    //			}

    var dpr = 1;

    if( "devicePixelRatio" in window ) {
        dpr = window["devicePixelRatio"];
    }

    height = height * dpr;
    width = width * dpr;

    var currentServer = LS2KIDS_CONSTANTS.curatedContentServers.__current;

    if( !currentServer || currentServer >= LS2KIDS_CONSTANTS.curatedContentServers.length ) {
        currentServer = 0;
    }

    var curatedContentServer = LS2KIDS_CONSTANTS.curatedContentServers[currentServer];

    LS2KIDS_CONSTANTS.curatedContentServers.__current = currentServer + 1;

    var prefix = "https://";
    if( !ApplicationData.globalConfiguration.contentServerSettings.enableSslCuratedContentServer ) {
        prefix = "http://";
    }

    var params = {
        "customerId": ApplicationData.globalConfiguration.contentServerSettings.contentServerCustomerId
    };

    if( height != 0 ) {
        params.height = height;
    }

    if( width != 0 ) {
        params.width = width;
    }

    const queryString = Object.entries(params)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');

    return prefix + curatedContentServer + "/logo/" + logo.guid + '?' + queryString;
}